(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--video-banner');
  const videos = SECTION.querySelectorAll('video');

  if (videos.length > 0) {
    const observerOptions = {
      threshold: 0.5, // 50% of video visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.play().catch((err) => {
            console.warn('Video play failed:', err);
          });
        } else {
          video.pause();
        }
      });
    }, observerOptions);

    videos.forEach((video) => observer.observe(video));
  }

})();
